import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/home/appuser/cancard-frontend/node_modules/@chakra-ui/react/dist/esm/components/box/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Container"] */ "/home/appuser/cancard-frontend/node_modules/@chakra-ui/react/dist/esm/components/container/container.js");
